/**
 * Stable internal flag keys used by the navigation registry and app code.
 * These never change when swapping env defaults for LaunchDarkly.
 *
 * When adding a flag, also update LAUNCHDARKLY_FLAG_KEY_MAP, getEnvFeatureFlagDefaults,
 * tests, and docs/feature-flags.md. See AGENTS.md — never enable production in
 * LaunchDarkly without express user permission.
 */
export const FEATURE_FLAG_KEYS = Object.freeze({
    CAD_AVL_SETTINGS: 'cadAvlSettings',
    UI_EARLY_ACCESS_INDICATOR: 'uiEarlyAccessIndicator',
    ENABLE_UNDER_MAINTENANCE: 'enableUnderMaintenance',
    ENABLE_UNDER_MAINTENANCE_POST_LOGIN: 'enableUnderMaintenancePostLogin',
    ENABLE_REMOVE_AGENCY_USER: 'enableRemoveAgencyUser',
    ENABLE_CHANGE_AGENCY_USER_ROLE: 'enableChangeAgencyUserRole',
    /** 2.2 feature bundle (PRD-3065 resend-invite eligibility, etc.). */
    ENABLE_22_FEATURES: 'enable22Features',
});

/**
 * Maps internal keys → LaunchDarkly dashboard flag keys.
 * LD integration merges remote values over env defaults using this map.
 */
export const LAUNCHDARKLY_FLAG_KEY_MAP = Object.freeze({
    [FEATURE_FLAG_KEYS.CAD_AVL_SETTINGS]: 'cad-avl-settings',
    [FEATURE_FLAG_KEYS.UI_EARLY_ACCESS_INDICATOR]: 'ui-early-access-indicator',
    [FEATURE_FLAG_KEYS.ENABLE_UNDER_MAINTENANCE]: 'enable-under-maintenance',
    [FEATURE_FLAG_KEYS.ENABLE_UNDER_MAINTENANCE_POST_LOGIN]: 'enable-under-maintenance-post-login',
    [FEATURE_FLAG_KEYS.ENABLE_REMOVE_AGENCY_USER]: 'enable-remove-agency-user',
    [FEATURE_FLAG_KEYS.ENABLE_CHANGE_AGENCY_USER_ROLE]: 'enable-change-agency-user-role',
    [FEATURE_FLAG_KEYS.ENABLE_22_FEATURES]: 'enable-2.2-features',
});

/**
 * Fallback defaults when LaunchDarkly is unavailable or omits a flag.
 * Feature rollout is controlled in LaunchDarkly — not by environment.
 */
export const getEnvFeatureFlagDefaults = () => ({
    [FEATURE_FLAG_KEYS.CAD_AVL_SETTINGS]: false,
    [FEATURE_FLAG_KEYS.UI_EARLY_ACCESS_INDICATOR]: false,
    [FEATURE_FLAG_KEYS.ENABLE_UNDER_MAINTENANCE]: false,
    [FEATURE_FLAG_KEYS.ENABLE_UNDER_MAINTENANCE_POST_LOGIN]: false,
    [FEATURE_FLAG_KEYS.ENABLE_REMOVE_AGENCY_USER]: false,
    [FEATURE_FLAG_KEYS.ENABLE_CHANGE_AGENCY_USER_ROLE]: false,
    [FEATURE_FLAG_KEYS.ENABLE_22_FEATURES]: false,
});
